import { defineComponent as _defineComponent } from 'vue'
import { bankAccountsTableFields } from '../../models/bankAccountsTableFields';
import BankAccountInfo from './BankAccountInfo.vue';
import { TableFieldDefinition } from 'ah-common-lib/src/models';
import { lastIbanDigits } from 'ah-common-lib/src/helpers/iban';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountsTable',
  props: {
    fields: { default: () => bankAccountsTableFields },
    allowDelete: { type: [Boolean, String], default: false },
    selectable: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { fields: TableFieldDefinition[], allowDelete: boolean | string, selectable: boolean | string };



const config = computed(() => {
  if (isSelectable.value) {
    return [{ header: '', key: 'selectRadio' }, ...props.fields];
  }
  return props.fields;
});

const isSelectable = computed(() => {
  return props.selectable !== false;
});

function onDeleteClick(event: MouseEvent, showModal: Function) {
  showModal();
  event.stopPropagation();
  event.stopImmediatePropagation();
}

return { __sfc: true,props, config, isSelectable, onDeleteClick, BankAccountInfo, lastIbanDigits }
}

})